import React, { useEffect, useState } from 'react';
import Card from 'src/components/common/Card.redesign';
// import LeaseGenerationForm from 'src/models/leasing/LeaseGenerationForm';
import moment from 'moment';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import MathUtil from 'src/util/MathUtil';
import ContractGenerationListDto from 'src/models/leasing/ContractGenerationListDto';

interface IAgreementCard {
    agreement: ContractGenerationListDto;
    clientNumber: number;
    projectNumber: number;

    navigate: (path: string) => void;
    showVoidDialog?: (agreement: ContractGenerationListDto) => void;
}

const AgreementCard = (props: IAgreementCard) => {
    const defaultActions: ContextMenuAction[] = [
        { text: 'Copy', action: () => console.log('copy contract') },
        { text: 'Promote', action: () => console.log('promote contract') }
    ];

    // const agreementData: AnyObject = JSON.parse(props.agreement.leaseFormData);
    const [menuActions, setMenuActions] = useState<ContextMenuAction[]>(defaultActions);

    useEffect(() => {
        if (props.agreement?.isInHand !== true && menuActions.find(ma => ma.text === 'Void') === undefined) {
            let newActions = [...menuActions];
            newActions.push({ text: 'Void', action: () => props.showVoidDialog(props.agreement) });

            setMenuActions(newActions);
        }
    }, [props]);

    // TODO: Find a way to maintain consistency between ContractGenerationList and established enums.
    const cardClick = () => {
        if (!props.agreement?.isVoid) {
            switch (props.agreement.leaseType) {
                case 'Oil and Gas Lease':
                    props.navigate(
                        `/clients/${props.clientNumber}/projects/${props.projectNumber}/acquisitions/lease-generation/ownerId/${props.agreement?.ownerLookUpId}/leases/${props.agreement.agreementId}`
                    );
                    break;
                case 'Solar Lease':
                    props.navigate(
                        `/clients/${props.clientNumber}/projects/${props.projectNumber}/acquisitions/lease-generation/ownerId/${props?.agreement?.ownerLookUpId}/solar-leases/${props.agreement.agreementId}`
                    );
                    break;
                case 'Surface Waiver':
                    props.navigate(
                        `/clients/${props.clientNumber}/projects/${props.projectNumber}/acquisitions/lease-generation/ownerId/${props?.agreement?.ownerLookUpId}/surface-waivers/${props.agreement.agreementId}`
                    );   
                    break;
                case 'BESS Lease':
                    props.navigate(
                        `/clients/${props.clientNumber}/projects/${props.projectNumber}/acquisitions/lease-generation/ownerId/${props?.agreement?.ownerLookUpId}/battery-storage/${props.agreement.agreementId}`
                    );
                    break;
                case 'Brine Lease':
                    props.navigate(
                        `/clients/${props.clientNumber}/projects/${props.projectNumber}/acquisitions/lease-generation/ownerId/${props?.agreement?.ownerLookUpId}/brine-leases/${props.agreement.agreementId}`
                    );
                    break;   
                case 'Right Of Way':
                    props.navigate(
                        `/clients/${props.clientNumber}/projects/${props.projectNumber}/acquisitions/lease-generation/ownerId/${props?.agreement?.ownerLookUpId}/right-of-ways/${props.agreement.agreementId}`
                    );
                    break;   
                default:
                    break;
            }
        }
    };

    // Ignore the &nbsp; it's just spacing ._. somehow the easiest way
    const leaseStatus = () => {
        if (props.agreement.isVoid) {
            // Redish
            return <span style={{color: '#c16363'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Void&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>;
        } else if (props.agreement.inHandDate !== null && props.agreement.inHandDate !== undefined) {
            // Greenish
            return <span style={{color: '#63c191'}}>&nbsp;&nbsp;&nbsp;In Hand&nbsp;&nbsp;&nbsp;&nbsp;</span>;
        } else if (props.agreement.isTransfer === true) {
            // Default Blue
            return <span>Transferred</span>;
        } else if (props.agreement.isCommitted === true) {
            // Purpleish
            return <span style={{color: '#6963c1'}}>Committed&nbsp;</span>;
        } else {
            // Tanish
            return <span style={{color: '#c1b363'}}>Rough Draft</span>;
        }
    };

    const rightPanel = () => {
        return (
            <>
                <span className="right-panel" style={{marginRight: '1.7rem', whiteSpace: 'nowrap'}}>
                    <span>{props.agreement?.leaseType} - {leaseStatus()}</span>
                </span>
            </>
        );
    };

    const dataCell = (label: string, data: string | number, isBlank = false, wholeNumber = false) => {
        if (isBlank) {
            return <span style={{ display: 'table-cell', width: '25%' }} />;
        }

        return (
            <span style={{ display: 'table-cell', width: '25%' }}>
                <span
                    style={{
                        width: '50%',
                        background: '#d5e2ee',
                        color: '#777',
                        fontSize: '.9em',
                        fontWeight: 'bold',
                        display: 'inline-block',
                        padding: '.2rem 0 .2rem 1rem',
                    }}
                >
                    {label}
                </span>
                <span style={{ width: '50%', textAlign: 'right', display: 'inline-block', fontSize: '.75em', padding: '.2rem 1rem .2rem 0' }}>
                    {wholeNumber ? data : MathUtil.cleanNumber((data as number))}
                </span>
            </span>
        );
    };

    const footerContent = (n: number) => (
        <div style={{ display: 'table', width: '100%', justifyContent: 'space-between', border: '1px solid #ccc' }}>
            {dataCell('Gross', props.agreement?.grossAcres)}
            {dataCell('Net', props.agreement?.netAcres)}
            {dataCell('Tract Count', props.agreement?.tractCount, false, true)}
        </div>
    );

    return (
        <Card
            badge={`${props.agreement?.leaseNumber + (Number(props.agreement?.tractCount) < 1 ? '- P' : '') || 'N/A'}`}
            onClick={cardClick}
            contextActions={!props.agreement?.isVoid && menuActions}
            newContext={true}
            showMenu={true}
            rightBadgePanel={rightPanel()}
        >
            <div className="agreements-card">
                <div className="agreements-card-row" style={{width: '100%', marginBottom: '1rem'}}>
                    <div style={{width: '32%'}}>
                        <span className="card-label">Owner: </span>
                        <span 
                            style={props?.agreement?.isVoid ? {textDecoration: 'line-through'} : {}} 
                            className="data"
                        >
                            {props?.agreement?.ownerName}
                        </span>
                    </div>
                    <div style={{width: '16%'}}>
                        <span className="card-label">Created Date: </span>
                        {props?.agreement?.createdDate ? moment(props?.agreement?.createdDate).format('MM-DD-YYYY') : 'N/A'}
                    </div>
                    <div style={{width: '20%'}}>
                        <span className="card-label">Leased By: </span>
                        {props?.agreement?.leasedBy || 'N/A'}
                    </div>
                    <div style={{width: '16%'}}>
                        <span className="card-label">Commit Date: </span>
                        {(props.agreement?.committedDate && props.agreement?.isCommitted === true) ? moment(props.agreement?.committedDate).format('MM-DD-YYYY') : 'N/A'}
                    </div>
                    <div style={{width: '16%'}}>
                        <span className="card-label">In Hand Date: </span>
                        {props.agreement?.inHandDate ? moment(props.agreement?.inHandDate).format('MM-DD-YYYY') : 'N/A'}
                    </div>
                </div>
            </div>
            <div style={{ width: '50%', marginLeft: '50%' }}>{footerContent(1)}</div>
        </Card>
    );
};

export default AgreementCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/AgreementCard.tsx